import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
@Component({
    selector: 'app-validation-error',
    template: `
      @if (isValid) {
      <span
        [ngClass]="{ 'show': isValid }"
        class="validation-error"
        pTooltip="{{errorMsg}}"
        tooltipPosition="top"
        tooltipStyleClass="toolTip"
        tooltipZIndex=150000
      >
        <i class="p-error pi pi-exclamation-circle"></i>
      </span> 
      }
    `,
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
  export class ValidationErrorComponent {
    @Input()
    public isValid  = true;

    @Input()
    public errorMsg  = "";
  }
